import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { LoggerService, tryNormalizeHttpError, OccEndpointsService } from '@spartacus/core'
import { catchError, Observable, throwError } from 'rxjs'
import { EBUnit } from 'src/app/features/product/interfaces/eb-product.interface'

@Injectable({ providedIn: 'root' })
export class EbUserAdapter {
  protected logger = inject(LoggerService)

  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService
  ) {}

  getCustomerMeasuringUnit(): Observable<EBUnit> {
    return this.http
      .get(this.occEndpointsService.buildUrl('customerMeasuringUnit'))
      .pipe(catchError(error => throwError(() => tryNormalizeHttpError(error, this.logger))))
  }

  setCustomerMeasuringUnit(unit): Observable<any> {
    const url = this.occEndpointsService.buildUrl('customerMeasuringUnit')
    return this.http
      .post(url, unit)
      .pipe(catchError(error => throwError(() => tryNormalizeHttpError(error, this.logger))))
  }
}
